import React from 'react'
import { faTable } from '@fortawesome/pro-regular-svg-icons'
import { SectionWrapper } from '../../../../common/components/SectionWrapper/SectionWrapper'
import {
  DetailRow,
  DetailInfo,
} from '../../../../common/components/DetailRow/DetailRow'
import { SubscriptionDetailObject } from '../../../../modules/subscription/reducer'

interface CustomMetadataSectionProps {
  subscriptionDetail: SubscriptionDetailObject
  classes: any
}

export const CustomMetadataSection: React.FC<CustomMetadataSectionProps> = ({
  subscriptionDetail,
  classes,
}) => {
  if (
    !subscriptionDetail?.metadata ||
    Object.keys(subscriptionDetail?.metadata).length === 0
  ) {
    return null
  }

  return (
    <SectionWrapper heading="Custom metadata" icon={faTable}>
      <div className={classes.sectionContent}>
        {Object.entries(subscriptionDetail.metadata).map(
          ([key, value], index) => (
            <DetailRow
              key={index}
              borderBottom={
                index <
                Object.keys(subscriptionDetail?.metadata || {}).length - 1
              }
            >
              <>
                <DetailInfo
                  title="Key"
                  value={key}
                  keyName={`metadataKey${index}`}
                />
                <DetailInfo
                  title="Value"
                  value={String(value)}
                  keyName={`metadataValue${index}`}
                />
              </>
            </DetailRow>
          )
        )}
      </div>
    </SectionWrapper>
  )
}
